import store from 'store2';
import constants from './constants';

const clearState = () => {
  store.remove(constants.SURVEY_STATE_NAME);
};

export default clearState;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/clearState.js